import TemplateView from '../../../../TemplateView'
import messageResource from '../../../../messageResource'

export default class LicensedToSection extends TemplateView {
    constructor({
        onEditButtonClick = () => {},
    }) {
        super()

        this.actions = {
            onEditButtonClick,
        }

        this.state = {
            companyName: '',
            companyAddress: '',
            primaryContact: '',
            acceptedAgreement: false,
            acceptedDate: '',
            documentsBaseUrl: '',
            serviceAgreementLink: '',
            dataProcessingAgreementLink: '',
            exhibitLink: '',
        }

        this.onStatePropertyChanged('companyName', (companyName) => {
            this.$companyName.text(companyName)
            this.$companyName.attr('title', companyName)
        })

        this.onStatePropertyChanged('companyAddress', (companyAddress) => {
            this.$companyAddress.text(companyAddress)
            this.$companyAddress.toggle(!!companyAddress)
        })

        this.onAnyStatePropertyChanged(['primaryContact', 'acceptedAgreement', 'acceptedDate'], () => {
            if (this.state.acceptedAgreement) {
                this.$acceptedBy.html(messageResource.getMessage('licenses.panel.accepted_by', [this.state.primaryContact, this.state.acceptedDate]))
            } else {
                this.$representedBy.text(messageResource.getMessage('licenses.panel.represented_by', [this.state.primaryContact]))
            }
            this.$representedBy.toggle(!this.state.acceptedAgreement)
            this.$acceptedBy.toggle(this.state.acceptedAgreement)
        })

        this.onAnyStatePropertyChanged(['documentsBaseUrl', 'serviceAgreementLink'], () => {
            this.$serviceAgreement.toggle(!!this.state.serviceAgreementLink)
            this.$serviceAgreement.attr('href', this.state.documentsBaseUrl + '/' + this.state.serviceAgreementLink)
        })

        this.onAnyStatePropertyChanged(['documentsBaseUrl', 'dataProcessingAgreementLink'], () => {
            this.$dataProcessingAgreement.toggle(!!this.state.dataProcessingAgreementLink)
            this.$dataProcessingAgreement.attr('href', this.state.documentsBaseUrl + '/' + this.state.dataProcessingAgreementLink)
        })

        this.onAnyStatePropertyChanged(['documentsBaseUrl', 'exhibitLink'], () => {
            this.$exhibit.toggle(!!this.state.exhibitLink)
            this.$exhibit.attr('href', this.state.documentsBaseUrl + '/' + this.state.exhibitLink)
        })
    }

    templateHtml() {
        return "<div class='licensedToSection'>" +
               "    <div class='icon'/>" +
               "    <div class='container'>" +
               "        <div class='header'>" +
               "            <div class='text'><%=licensedTo%></div>" +
               // TODO makovchik / fedoreeva this button is needed when ready edit pop-up
               // "            <div class='editButton'><%=editButton%></div>" +
               "        </div>" +
               "        <div class='content'>" +
               "            <div class='companyName'/>" +
               "            <div class='companyAddress'/>" +
               "            <div class='representedBy'/>" +
               "            <a class='serviceAgreement' target='_blank'><%=serviceAgreement%></a>" +
               "            <a class='dataProcessingAgreement' target='_blank'><%=dataProcessingAgreement%></a>" +
               "            <a class='exhibit' target='_blank'><%=exhibit%></a>" +
               "            <div class='acceptedBy'/>" +
               "        </div>" +
               "    </div>" +
               "</div>"
    }

    messageKeys() {
        return {
            licensedTo: 'licenses.panel.licensed_to',
            editButton: 'common.edit',
            serviceAgreement: 'licenses.panel.service_agreement',
            dataProcessingAgreement: 'licenses.panel.data_processing_agreement',
            exhibit: 'licenses.panel.exhibit',
        }
    }

    afterRender() {
        this.$companyName = this.find('.companyName')
        this.$companyAddress = this.find('.companyAddress')
        this.$representedBy = this.find('.representedBy')
        this.$acceptedBy = this.find('.acceptedBy')

        this.$serviceAgreement = this.find('.serviceAgreement')
        this.$dataProcessingAgreement = this.find('.dataProcessingAgreement')
        this.$exhibit = this.find('.exhibit')

        this.find('.editButton').on('click', () => this.actions.onEditButtonClick())
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/companyInfoPanel/LicensedToSection.js